import { render, staticRenderFns } from "./BusinessBanner.vue?vue&type=template&id=32f4b226&scoped=true"
import script from "./BusinessBanner.vue?vue&type=script&lang=js"
export * from "./BusinessBanner.vue?vue&type=script&lang=js"
import style0 from "./BusinessBanner.vue?vue&type=style&index=0&id=32f4b226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f4b226",
  null
  
)

export default component.exports